/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import {esputnikTracker, eventEmitter} from './common/baseData'

import './catalog/style.css';
import './catalog/brands-page';
import './catalog/offers-list/colors.css';

import React from 'react'
import {createRoot} from 'react-dom/client'
import BrandPage from './Componentsv2/BrandPage/BrandPage'
import {ApplicationContextProvider,} from './Componentsv2/Context/ApplicationContextProvider'

const brandPageRoot = document.getElementById('brand-page-root');
if (brandPageRoot) {
	createRoot(brandPageRoot).render(
		<ApplicationContextProvider>
			<BrandPage
				banners={window.brandPageBanners || []}
				sections={window.brandPageSections || []}
				novelties={window.brandPageNovelties || {}}
				categoryBlocks={window.brandPageCategoryBlocks || []}
				messages={window.brandPageMessages || {}}
				viewedProducts={window.viewedProducts || {}}
				youtubeArticles={window.homePageYouTube || []}
			/>
		</ApplicationContextProvider>
	);
}


// Esputnik Tracker
let categoryId = (document.querySelector('[data-section]'))
	? document.querySelector('[data-section]').dataset.section
	: null;

eventEmitter.on('EsputnikLoaded', () => {
	esputnikTracker.CategoryPage(categoryId);
});